module.exports = __webpack_public_path__ + "static/img/gzType.4f40742.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/haierProduct/images/gzType.jpg
// module id = 2OTM
// module chunks = 4